export default __webpack_public_path__ + "static/media/SEEDCampusConnect.67720cfd.jpg";